import { Stack } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { FC, ReactElement } from 'react';
import { FilterSearchBar } from '../FilterSearchBar';
import useQueryParamsStore from 'src/utils/hooks/useQueryParamsStore';
import { useStores } from 'src/utils/hooks/useStores';
import { FilterStatusFolders } from '../FilterStatusFolders/FilterStatusFolders';

interface FilterTabletDesktopContentLayoutProps {
  clearFilters: () => void;
  screeningQuestionFilters: ReactElement;
}

export const FilterTabletDesktopContentLayout: FC<FilterTabletDesktopContentLayoutProps> =
  observer(({ clearFilters, screeningQuestionFilters }) => {
    const { jobApplicationStore } = useStores();
    const [, setQueryQueryParams] = useQueryParamsStore();

    const onSearch = () => {
      clearFilters();
      jobApplicationStore.clearAllSelected();
      return setQueryQueryParams.navigateToSearch(
        jobApplicationStore.searchText,
      );
    };

    const onChange = (text: string) => {
      jobApplicationStore.updateSearchText(text);
    };

    const filtersSearchBar = (
      <FilterSearchBar
        onChange={onChange}
        value={jobApplicationStore.searchText}
        lastResultSearchText={jobApplicationStore.lastResultSearchText}
        onSearch={onSearch}
      />
    );

    return (
      <Stack space="large">
        <Stack space="gutter">
          {filtersSearchBar}
          <FilterStatusFolders />
        </Stack>
        {screeningQuestionFilters}
      </Stack>
    );
  });
